export default __webpack_public_path__ + "static/media/fmd_white.736697c0.svg";